import { render, staticRenderFns } from "./r-smart-offer-bundle-magical-cinema.vue?vue&type=template&id=3ee8d201"
import script from "./r-smart-offer-bundle-magical-cinema.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-magical-cinema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee8d201')) {
      api.createRecord('3ee8d201', component.options)
    } else {
      api.reload('3ee8d201', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-magical-cinema.vue?vue&type=template&id=3ee8d201", function () {
      api.rerender('3ee8d201', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-magical-cinema/r-smart-offer-bundle-magical-cinema.vue"
export default component.exports